<template>
  <div class="page-user-add">
    <div class="container mt-5">
      <div class="columns is-centered">
        <div class="column is-half">

          <div class="page-header">
            <h1 class="title is-3 mb-2">Add User</h1>
            <p class="subtitle is-6 has-text-grey">
              Create a new user account.
            </p>
          </div>

          <form @submit.prevent="submitForm" class="box add-card">
            <div
              v-if="errors.length"
              class="notification is-danger is-light"
            >
              <p
                v-for="error in errors"
                :key="error"
                class="mb-1"
              >
                {{ error }}
              </p>
            </div>

            <div class="form-section">
              <h2 class="title is-5 mb-4">Account Details</h2>

              <div class="field">
                <label class="label">First Name</label>
                <div class="control has-icons-left">
                  <input
                    v-model="first_name"
                    type="text"
                    class="input"
                    placeholder="Enter first name"
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-user"></i>
                  </span>
                </div>
              </div>

              <div class="field">
                <label class="label">Email</label>
                <div class="control has-icons-left">
                  <input
                    v-model="email"
                    type="email"
                    class="input"
                    placeholder="Enter email address"
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-envelope"></i>
                  </span>
                </div>
              </div>
            </div>

            <div class="form-section">
              <h2 class="title is-5 mb-4">Password</h2>

              <div class="field">
                <label class="label">Password</label>
                <div class="control has-icons-left">
                  <input
                    v-model="password"
                    type="password"
                    class="input"
                    placeholder="Enter password"
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-lock"></i>
                  </span>
                </div>
              </div>

              <div class="field">
                <label class="label">Repeat Password</label>
                <div class="control has-icons-left">
                  <input
                    v-model="password2"
                    type="password"
                    class="input"
                    placeholder="Repeat password"
                  >
                  <span class="icon is-small is-left">
                    <i class="fas fa-lock"></i>
                  </span>
                </div>
              </div>
            </div>

            <div class="field is-grouped is-grouped-right mt-5">
              <div class="control">
                <router-link to="/users" class="button is-light">
                  Cancel
                </router-link>
              </div>

              <div class="control">
                <button
                  class="button is-primary"
                  :class="{ 'is-loading': saving }"
                  :disabled="saving"
                >
                  Add User
                </button>
              </div>
            </div>
          </form>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { toast } from 'bulma-toast'

export default {
  name: 'UserAddView',

  data() {
    return {
      first_name: '',
      email: '',
      password: '',
      password2: '',
      errors: [],
      saving: false
    }
  },

  mounted() {
    document.title = 'Add User | SCE Electrical'
  },

  methods: {
    showToast(message, type = 'is-success') {
      toast({
        message,
        type,
        dismissible: true,
        pauseOnHover: true,
        duration: 2000,
        position: 'bottom-right'
      })
    },

    formatErrorMessage(property, message) {
      const label = property.charAt(0).toUpperCase() + property.slice(1)

      return `${label}: ${Array.isArray(message) ? message[0] : message}`
    },

    async submitForm() {
      this.errors = []

      if (!this.first_name) {
        this.errors.push('First name is required.')
      }

      if (!this.email) {
        this.errors.push('Email is required.')
      }

      if (!this.password) {
        this.errors.push('Password is required.')
      }

      if (this.password !== this.password2) {
        this.errors.push('Passwords do not match.')
      }

      if (this.errors.length) {
        return
      }

      this.saving = true

      try {
        const formData = {
          first_name: this.first_name,
          email: this.email,
          password: this.password
        }

        await axios.post('/api/v1/users/create/', formData)

        this.showToast('User created successfully')

        this.$router.push('/users')
      } catch (error) {
        if (error.response) {
          for (const property in error.response.data) {
            this.errors.push(
              this.formatErrorMessage(property, error.response.data[property])
            )
          }

          console.log(JSON.stringify(error.response.data))
        } else if (error.message) {
          this.errors.push('Something went wrong. Please try again.')
          console.log(JSON.stringify(error))
        }
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped>
.page-user-add {
  min-height: 100%;
}

.page-header {
  margin-bottom: 1.5rem;
}

.add-card {
  border-radius: 12px;
}

.form-section {
  padding-bottom: 1.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #eeeeee;
}

.form-section:last-of-type {
  margin-bottom: 0;
}

.notification p:last-child {
  margin-bottom: 0 !important;
}
</style>